/* eslint-disable import/prefer-default-export */
export const getMonitorGraphQLEndpoint = state => `${state.config.apiUrl}/v1/monitor/graphql`;



// WEBPACK FOOTER //
// ./src/services/smartguard/selectors.js